import { render, staticRenderFns } from "./DropdownButton.vue?vue&type=template&id=5a552a28&scoped=true&"
import script from "./DropdownButton.vue?vue&type=script&lang=ts&"
export * from "./DropdownButton.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownButton.vue?vue&type=style&index=0&id=5a552a28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a552a28",
  null
  
)

export default component.exports